import React, { Component } from "react";
import DateBadge from "../components/DateBadge";
import Parser from 'html-react-parser';

class BlogPost extends Component {
	constructor(props) {
		super(props);

		let startDate = new Date(props.event.published);

		this.state = {
			summary: props.event.title,
			description: props.event.content,
			start: { dateTime: startDate },
			postUrl: props.event.url,
			isOldPost: props.isOldPost
		}
	}

	render() {
		let descClass = "nf-entry-desc site-text" + (this.state.isOldPost ? " nf-entry-fade" : "");
		let buttonText = this.state.isOldPost ? "Read more" : "View post";
		return (
			<article className="nf-entry">
				<div className="nf-entry-date">
					<DateBadge startDate={this.state.start} />
				</div>
				<div className="nf-entry-body">
					<h3 className="nf-entry-title">{this.state.summary}</h3>
					<div className={descClass}>{this.state.description ? Parser(this.state.description) : ""}</div>
					<a className="nf-entry-link" href={this.state.postUrl} target="_blank" rel="noopener noreferrer">
						{buttonText} &rarr;
					</a>
				</div>
			</article>
		);
	}
}

export default BlogPost;
